import {TweenMax, Power1} from 'gsap';

class HiddenLayer {

    public $template: JQuery;

    constructor(selector: JQuery) {

        this.$template = selector;
        this.init();
    }

    public instance(): HiddenLayer {
        return this;
    }

    public remove(): void {
    }

    public reset(): void {
        if (this.items && this.items.length > 0) {
            for (let i: number = 0; i < this.items.length; i++) {
                let item: JQuery = this.items[i];
                TweenMax.set(item, {
                    y: 100,
                    alpha: 0
                });
            }
        }
    }


    private init(): void {
        this.createItem();
        this.reset();
    }


    private items: JQuery[];

    private createItem(): void {

        this.items = [];
        let itemTotal: number = this.$template.find(".hide-item").length;
        for (let i: number = 0; i < itemTotal; i++) {
            let item: JQuery = this.$template.find(".hide-item:eq(" + i + ")");
            this.items.push(item);
        }
    }


    public transitionItem(): void {
        for (let i: number = 0; i < this.items.length; i++) {
            let item: JQuery = this.items[i];
            let delayTime: number = i / this.items.length;
            TweenMax.to(item, 0.5, {
                delay: delayTime,
                y: 0,
                alpha: 1
            });
        }
    }


    public transitionIn(): void {

        TweenMax.killTweensOf(this);

        this.$template.addClass("active");
        TweenMax.set(this.$template, {
            height: "auto"
        });
        TweenMax.from(this.$template, 0.7, {
            height: 0,
            ease: Power1.easeOut,
            onComplete: this.onTransitionComplete.bind(this),
            onCompleteParams: ["IN_COMPLETED"]
        });
        this.transitionItem();
    }

    public transitionOut(): void {

        TweenMax.killTweensOf(this);
        TweenMax.to(this.$template, 0.7, {
            delay: 0.3,
            height: 0,
            ease: Power1.easeOut,
            onComplete: this.onTransitionComplete.bind(this),
            onCompleteParams: ["OUT_COMPLETED"]
        });
    }

    private onTransitionComplete(type: string): void {

        if (type == "OUT_COMPLETED") {
            this.reset();
            this.$template.removeClass("active");
        }
    }
}

export = HiddenLayer;